import { render, staticRenderFns } from "./RulesDialog.vue?vue&type=template&id=4ce403dc&scoped=true"
import script from "./RulesDialog.vue?vue&type=script&lang=js"
export * from "./RulesDialog.vue?vue&type=script&lang=js"
import style0 from "./RulesDialog.vue?vue&type=style&index=0&id=4ce403dc&prod&lang=scss&scoped=true"
import style1 from "./RulesDialog.vue?vue&type=style&index=1&id=4ce403dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce403dc",
  null
  
)

export default component.exports